import AdminLayout from '@components/Layout/AdminLayout'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { isAuthenticated } from '@utils/auth';

export const Route = createFileRoute('/(admin)/_admin')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
      });
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AdminLayout>
        <Outlet />
    </AdminLayout>
  )
}
